import React from "react";
import FormAutocompleteSelectCheckbox, { FormAutocompleteSelectCheckboxProps } from "ui/Form/SelectCheckbox/AutocompleteSelectCheckbox";

import { Field, UseFieldConfig } from "react-final-form";

type Props = FormAutocompleteSelectCheckboxProps & UseFieldConfig<string>;

const AutocompleteSelectCheckboxField: React.FC<Props> = ({
    labelProps,
    fieldGroupProps,
    fieldControlProps,
    adornmentStart,
    adornmentEnd,
    inputProps,
    listHeader,
    adormentRight,
    ...fieldProps
}) => {
    return (
        <Field name={inputProps.name} {...fieldProps}>
            {({ input, meta }) => {
                return (
                    <FormAutocompleteSelectCheckbox
                        error={!!(meta.error || meta.submitError)}
                        errorMessage={meta.error || meta.submitError}
                        labelProps={labelProps}
                        fieldGroupProps={fieldGroupProps}
                        fieldControlProps={fieldControlProps}
                        adornmentStart={adornmentStart}
                        adornmentEnd={adornmentEnd}
                        inputProps={Object.assign({}, input, inputProps)}
                        listHeader={listHeader}
                        adormentRight={adormentRight}
                        {...fieldProps}
                    />
                );
            }}
        </Field>
    );
};

export default AutocompleteSelectCheckboxField;
